import i18n from 'i18n'
import * as React from "react"
import { SelectSeeker } from "ui-seeker/core"

const OPTIONS = [
    { label: '30 days', value: '30' },
    { label: '60 days', value: '60' },
    { label: '90 days', value: '90' },
    { label: '120 days', value: '120' },
]

export default function SelectAlertDaysRanged({...props}) {

    const myProps = {
        placeholder: i18n.t('common:filters.selectNoDays'), label: i18n.t('common:filters.daysRangedRequired'),
        firstSelect: false, isClearable: false, options: OPTIONS,
        formatOptionLabel: opt => i18n.t('common:units.days', { count: Number(opt?.value) }),
        icon: {icon: 'calendar-day'}, isMulti: false,
        ...props
    }

    return <SelectSeeker {...myProps} />
}